import React, { FC } from 'react';
import { Wrapper } from './styles';

type Props = {
  id?: string;
  fitContentHeight?: boolean;
};

const Section: FC<Props> = props => {
  return <Wrapper {...props} />;
};

export default Section;
